import { AgencyNavbar } from "../components/agency/AgencyNavbar";
import { AgencyHero } from "../components/agency/AgencyHero";
import { AgencyAbout } from "../components/agency/AgencyAbout";
import { ServicesSection } from "../components/agency/ServicesSection";
import { StackSection } from "../components/agency/StackSection";
import { ProcessSection } from "../components/agency/ProcessSection";
import { FounderSection } from "../components/agency/FounderSection";
import { AgencyProjects } from "../components/agency/AgencyProjects";
import { ContactSection } from "../components/ContactSection";
import { SiteFooter } from "../components/SiteFooter";
import { SEO } from "../components/SEO";
import mascot from "../assets/geekcow-mascot.png";

const FOOTER_LINKS = [
  { label: "Services", section: "services" },
  { label: "Process", section: "process" },
  { label: "The founder", section: "founder" },
  { label: "Projects", section: "projects" },
  { label: "About", section: "about" },
  { label: "Contact", section: "contact" },
];

export function AgencyPage() {
  const scrollToSection = (sectionId: string) =>
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <div className="relative w-full bg-[#e7f1f1] overflow-x-hidden">
      <SEO
        variant="agency"
        title="Geekcow Creative Studio — Secure, GDPR-ready & accessible websites"
        description="We design and build secure, GDPR/AVG-compliant and WCAG-accessible WordPress websites for European SMEs and NGOs. Audited, not templated — every build ships with a signed compliance report."
        url="https://www.geekcow.com/"
      />
      <AgencyNavbar />

      <main>
        <div id="landing">
          <AgencyHero />
        </div>
        <div id="about">
          {/* "Know more" continues the story on-page rather than sending the
              visitor off to LinkedIn — Our Process is the literal answer to it. */}
          <AgencyAbout onKnowMore={() => scrollToSection("process")} />
        </div>
        {/* Process follows straight on from "Who we are" — it answers the
            "Know more" link and explains the studio before pricing appears. */}
        <div id="process">
          <ProcessSection />
        </div>
        <div id="services">
          <ServicesSection />
        </div>
        <div id="stack">
          <StackSection />
        </div>
        {/* Testimonials are off while agency references are still being collected.
            The component and its data are untouched — restore this block to bring
            it back. (The profile page keeps its own testimonials.) */}
        <div id="projects">
          <AgencyProjects />
        </div>
        {/* Last thing before the form: who you would actually be talking to. */}
        <div id="founder">
          <FounderSection />
        </div>
        <div id="contact">
          <ContactSection
            heading="Contact Us"
            intro={
              <>
                <span className="text-[#141414]">We are </span>
                <span className="text-[#f42536]">ready </span>
                <span className="text-[#141414]">and </span>
                <span className="text-[#256af4]">excited </span>
                <span className="text-[#141414]">to start </span>
                <span className="text-[#22c365]">your project.</span>
              </>
            }
            note="Fill out the form — we'll beam back within a day."
            successNote="Message received loud and clear — we'll beam back within a day."
            showFooter={false}
            illustration={mascot}
            illustrationAlt="GeekCow mascot"
            illustrationShape="free"
            // Scope buckets that map to what the studio actually offers, rather
            // than the profile's default set.
            scopeOptions={[
              { label: "Website", color: "#22c365" },
              { label: "Web / Mobile App", color: "#256af4" },
              { label: "E-commerce", color: "#ffc803" },
              { label: "Branding & Design", color: "#f42536" },
              { label: "Compliance Audit", color: "#01E12D" },
              { label: "AI / MVP", color: "#003e5b" },
              { label: "Maintenance & Hosting", color: "#256af4" },
            ]}
          />
        </div>
      </main>

      <SiteFooter
        face="agency"
        blurb="International Web & App Development Agency"
        navLinks={FOOTER_LINKS}
        onSectionClick={scrollToSection}
      />
    </div>
  );
}
